import React, { useEffect, useState } from "react";
import DropdownIcon from "../../../assets/images/DropDownIcon";
import http from "../../../rest/http";

export const selectBoxStyle: React.CSSProperties = {
  appearance: "none",
  color: "black", // Hide the default dropdown arrow provided by the browser
};
interface SelectProps {
  handleOnChange: (
    event: React.ChangeEvent<HTMLSelectElement>,
    key: any,
    payloadName: any
  ) => void;
  options: Option[];
  placeholder?: string;
  name?: string;
  value?: string;
  label?: string;
  borderColor?: string;
  payloadName?: string;
  key?: string;
  apiUrl?: string;
  dependsOn?: string;
  updatedArray?: any;
  setIsSpecialization?: any;
  setSpecilizationOptions?: any;
  setDropdownOptionsDynamic?: any;
  dropdownOptionsDynamic?: any;
  isRequired?: boolean;
  setSpeclizationIsManditory? :any;
  specilizationIsManditory?:any;
  setBankDetailsManditory? : any;
  bankDetailsManditory?: any;
  valueForOnboarding?:any;
  editMode?:any;
  // fetchOptions?:(apiUrl:string | undefined) => void;
}

interface Option {
  id: string;
  value: string;
  label: string;
  name: string;
  specializationMultiMandatory: boolean;
}
const SelectDropdown = ({
  handleOnChange,
  options,
  placeholder,
  name,
  value,
  label,
  borderColor,
  payloadName,
  key,
  apiUrl,
  dependsOn,
  updatedArray,
  setIsSpecialization,
  setSpecilizationOptions,
  setDropdownOptionsDynamic,
  dropdownOptionsDynamic,
  isRequired,
  setSpeclizationIsManditory,
  specilizationIsManditory,
  setBankDetailsManditory,
  bankDetailsManditory,
  valueForOnboarding,
  editMode,
}: 
SelectProps) => {
  const [dropdownOptions, setDropdownOptions] = useState<Option[]>(options);
  const [dropDownValue, setDropDownValue] = useState(value);
  useEffect(() => {
    if (Array.isArray(options)) {
      setDropdownOptions(options);
    }
  }, [options]);

  useEffect(() => {
    if (editMode && value) {
      const formattedValue =
        typeof value === "string" && !value.startsWith("{")
          ? JSON.stringify({ value })
          : value;
  
      const fakeEvent = {
        target: {
          name: name || "",
          value: formattedValue,
        },
      } as React.ChangeEvent<HTMLSelectElement>;
  
      handleOnChange(fakeEvent, payloadName, key);
      setDropDownValue(formattedValue);
    }
  }, []);
  const fetchOptionsDynamic = async (apiUrl: string | undefined) => { 
    try {
      if (!apiUrl) return;
      const response = await http.get(apiUrl);
      // if(response[0]?.specializationMultiMandatory === true){
      //   setSpeclizationIsManditory(true);
      // }
      // if(response[0]?.bankDetailsMandatory === true){
      //   setBankDetailsManditory(true);
      // }
      if (Array.isArray(response)) {
        if (payloadName === "reportingUserId") {
          const formattedUsers = (response as any[]).map((user: any) => ({
            id: user.id, // explicitly including id
            name: `${user.firstName} ${user.lastName}`.trim(),
            ...user, // preserve the rest of the fields if needed
          }));
          setDropdownOptionsDynamic(payloadName, formattedUsers);
        } else {
          const data = { payloadName: payloadName, options: response };
          setDropdownOptionsDynamic(payloadName, response);
        }
      } else if (typeof response === "object" && response !== null) {
        if (payloadName === "typeId") {
          setDropdownOptionsDynamic(payloadName, response.types);
        } 
        else if (payloadName === "reportingRoleId") {
          setDropdownOptionsDynamic(payloadName, response.reportingRoles);

        }
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };


  const replaceUrlPlaceholders = (
    url: string,
    payload: Record<string, any>
  ): string => {
    // Replace placeholders like {deptId} with corresponding values from payload
    let updatedUrl = url.replace(/\{(\w+)\}/g, (_, key) => payload[key] || "");

    // Append query parameters if needed
    if (url.includes("?")) {
      Object.keys(payload).forEach((key) => {
        if (
          updatedUrl.includes(`?${key}=`) ||
          updatedUrl.includes(`&${key}=`)
        ) {
          updatedUrl = updatedUrl.replace(`${key}=`, `${key}=${payload[key]}`);
        }
      });
    }

    return updatedUrl;
  };

  const handleDropdownClick = async () => {
    if (!dependsOn) {
      console.log("No dependency, fetching options directly from API");
      fetchOptionsDynamic(apiUrl);
    } else {
      // BLOCK fetch if parent field is not selected
      const dependencyValue = updatedArray?.[dependsOn];
      if (!dependencyValue) {
        setDropdownOptions([]);
        return;
      }
      let urlForGettingDropDownOptionsUrl;
  
      if (payloadName === "reportingUserId") {
        urlForGettingDropDownOptionsUrl = `${apiUrl}${dependencyValue}`;
      } else {
        urlForGettingDropDownOptionsUrl = replaceUrlPlaceholders(apiUrl ?? "", updatedArray);
      }

      fetchOptionsDynamic(urlForGettingDropDownOptionsUrl);
    }


  };


  const handelvalueChange = (event: any) => {
    setDropDownValue(event.target.value);
  };
  const selectRef = React.useRef<HTMLSelectElement>(null);
  const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null);
  
  const [prevValue, setPrevValue] = useState<string | null>(null);
  const getValueFromStore = (reduxData: any[], fieldName: any): string => {
    if (!Array.isArray(reduxData)) return "";

    const attr = reduxData.find((item) => item.name === fieldName);
    return attr?.value || "";
  };

  return (
    <div
      className={`relative mt-5 border ${
        borderColor ? borderColor : "border-sideMenuHelpBox"
      } rounded-xl focus-within:border-blue-500`}
    >
      <label
         htmlFor={label}
        className={`absolute top-0 left-2 bg-white px-2 labelText ${
          borderColor === "border-redColor" && "text-redColor"
        }`}
      >
       <div className="flex">  {label} {isRequired && <div className="text-redColor quickLinksTitle pl-1">*</div> }</div>
      </label>
      <select
        id={label}
        ref={selectRef}
        name={name}
        onFocus={()=>{
          setDropDownValue("");
          handleDropdownClick()}}
        onChange={(event) => {
          handleOnChange(event, payloadName, key);
          handelvalueChange(event);
        }}
        onClick={(e) => {
          const currentIndex = selectRef.current?.selectedIndex;
          if (currentIndex === lastSelectedIndex) {
            // ✅ Trigger logic again if same option reselected
            const fakeEvent = {
              target: {
                name: name || "",
                value: selectRef.current?.value,
              },
            } as React.ChangeEvent<HTMLSelectElement>;
      
            handleOnChange(fakeEvent, payloadName, key);
            handelvalueChange(fakeEvent);
          }
          setLastSelectedIndex(currentIndex ?? null);
        }}
     
        className={`w-full p-4 ${
          value && value.toString().length !== 0
            ? "text-inputTextColor "
            : "text-sideMenuHelpBox"
        } placeHolderText border border-transparent rounded-2xl focus:outline-none bg-white`}
        required
        // value={dropDownValue || ""}
        value={dropDownValue || (valueForOnboarding && getValueFromStore(valueForOnboarding, payloadName)) || ''}
        style={selectBoxStyle}
      >
         {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}

        {/* dropdownOptions?.types || options?.specializations ||  */}
        {payloadName &&
          dropdownOptionsDynamic?.[payloadName]?.map(
            (option: any, index: any) => (
              <option
                key={index}
                value={JSON.stringify({
                  value:
                    payloadName === "branches"
                      ? option
                      : dependsOn === null && apiUrl === null
                      ? option?.value
                      : option?.id,
                  isSpecialization: option?.specializationMultiMandatory,
                  name: option,
                  multipleBranchAccess: option?.multipleBranchAccess,
                  isBankDetailsManditory: option?.bankDetailsMandatory,
                })}
                className="text-inputTextColor placeHolderText"
                // data-isspecialization={option?.specializationMultiMandatory}
              >
                {apiUrl === null ? option.value : option.name}
              </option>
            )
          )}
        {options.map((option, index) => (
          <option
            key={index}
            value={JSON.stringify({ value: option.value })}
            className="text-inputTextColor placeHolderText"
          >
          {option.value}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 top-2 flex items-center pr-3 pointer-events-none">
        <DropdownIcon />
      </div>
    </div>
  );
};

export default SelectDropdown;
